export default class Error {

    constructor() {
        this.ErrorTxt = [
            '请输入正确的手机号',
            '手机号格式错误',
            '请先获取验证码',
            '请输入手机短信中的验证码',
            '手机验证码已下发，请耐心等候！',
            '请输入正确的图片验证码',
            '请输入正确的手机验证码',
            '请输入正确的邮箱地址',
            '密码长度是8-16位',
            '密码格式不正确',
            '确认密码和密码不一致',
            '密码不能是纯数字',
            '请输入正确的邮箱地址',
            '请输入图片验证码',
            '确认密码不能为空',
            '密码强度太低'
        ];
    }
    show (obj, txt) {
        let parent = obj.parents('dd');
        if (parent.find('.span-error').length === 0) {
            parent.append('<div class="span-error"></div>');
        }
        parent.find('.span-error').html(txt).show();
    }
    hide (obj) {
        let parent = obj.parents('dd');
        if (parent.find('.span-error')) {
            parent.find('.span-error').hide();
        }
    }

};



// WEBPACK FOOTER //
// ./src/module/passport-password/error.js